export default __webpack_public_path__ + "static/media/15.8db2c176.jpg";